const className = 'LeastRecentlyUsedMap';

function _validateCapacity(capacity) {
  if (typeof capacity !== 'number' || capacity < 1) {
    throw new Error(`${className}: invalid capacity value passed: ${capacity}`);
  }
}

function _validateKey(key) {
  if (typeof key !== 'string' && typeof key !== 'number') {
    throw new Error(`${className}: invalid key passed ${key}`);
  }
}

function _validateValue(value) {
  if (value === undefined) {
    throw new Error(`${className}: missed value param`);
  }
}

/**
 * LeastRecentlyUsedMap
 * A map implementation with a fixed capacity which removes the least recently used entry if an entry
 * is added when full. Least recently used algorithm is performed for get/put methods.
 * @example
 *  const map = new LeastRecentlyUsedMap(N);
 *  map.put('key', {});
 *  map.get('key');
 */
export default class LeastRecentlyUsedMap {
  constructor(capacity) {
    _validateCapacity(capacity);

    this._capacity = capacity;
    this._keys = [];
    this._storage = {};
  }

  get(key) {
    _validateKey(key);

    if (!this._storage[key]) {
      return;
    }

    this._removeKey(key);
    this._keys.unshift(key);
    // eslint-disable-next-line consistent-return
    return this._storage[key];
  }

  put(key, value) {
    _validateKey(key);
    _validateValue(value);

    this._removeKey(key);
    this._keys.unshift(key);
    if (this._keys.length === this._capacity + 1) {
      delete this._storage[this._keys.pop()];
    }

    this._storage[key] = value;
  }

  _removeKey(key) {
    const index = this._keys.indexOf(key);
    if (index !== -1) {
      this._keys.splice(index, 1);
    }
  }
}
